import { adminAxios, protectedAxios } from '@/lib/axiosInstance';
import { ApiResponse } from '@/types/api/common';
import {
  AdminGetAllUsersResponse,
  DeleteReason,
  DeleteUserPayload,
  GetAllUserResponse,
  UserStatus,
} from '@/types/api/user';

export const getAllUsers = async (search = ''): Promise<GetAllUserResponse> => {
  const response = await protectedAxios.get<GetAllUserResponse>(
    `/user?search=${search}`
  );

  return response.data;
};

// admin apis
export const getAllUsersAdmin = async (payload: {
  search?: string;
  page?: number;
  limit?: number;
  orderBy?: string; // Format: field:direction (e.g., email:desc, userName:asc)
  status?: UserStatus;
}): Promise<AdminGetAllUsersResponse> => {
  const response = await adminAxios.get<AdminGetAllUsersResponse>(
    `/user/admin/users`,
    { params: payload }
  );

  return response.data;
};

export const UpdateUserStatus = async (payload: {
  userId: string;
  status: 'enable' | 'disable';
}): Promise<ApiResponse<string>> => {
  const response = await adminAxios.patch<ApiResponse<string>>(
    `/user/admin/update-status/${payload.userId}`,
    { state: payload.status }
  );

  return response.data;
};

export const DeleteUser = async (
  payload: DeleteUserPayload
): Promise<ApiResponse<string>> => {
  const response = await adminAxios.delete<ApiResponse<string>>(
    `/user/admin/delete-user/${payload.userId}?reasonId=${payload.reasonId}&otherReason=${payload.otherReason}`
  );

  return response.data;
};

export const GetDeleteReasons = async (): Promise<
  ApiResponse<DeleteReason[]>
> => {
  const response = await adminAxios.get<ApiResponse<DeleteReason[]>>(
    `/user/admin/delete-reasons`
  );

  return response.data;
};

export const UpdateUserRole = async (payload: {
  userId: string;
  role: string;
}): Promise<ApiResponse<string>> => {
  const response = await adminAxios.patch<ApiResponse<string>>(
    `/user/admin/update-user-role/${payload.userId}`,
    { role: payload.role }
  );

  return response.data;
};
